import Splide from '@splidejs/splide';

$(function () {
  if($('.splide.cmn-splide01').length) {
    const splide01 = new Splide(".splide.cmn-splide01", {
      type: "loop",
      gap: 50,
      fixedWidth: "300px",
      focus: "center",
      arrows: true,
      pagination: false,
      breakpoints: {
        768: {
          gap: 15,
          fixedWidth: "220px",
        },
      },
    })
    splide01.mount();
  }
});

$(function () {
  if($('.splide.cmn-mvSplide01').length) {
    const splide02 = new Splide(".splide.cmn-mvSplide01", {
      autoplay: true,
      type: "fade",
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      arrows: false,
      pagination: false,
      interval: 5000, // 自動再生の間隔
      speed: 4000, // スライダーの移動時間
    })
    splide02.mount();
  }
});

$(function () {
  const options = {
    fixedWidth: "100%",
    type: "loop",
    gap: '25px',
    arrows: false,
    drag: false,
    flickPower: 100,
    pagination: false,
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  };
  const splide = new Splide(".splide.splide-chara", options);
  splide.mount(window.splide.Extensions);
});
